import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

export interface BottomSheetActions {
    text: string;
    icon?: string;
    choiceName: string;
}

export interface BottomSheetOptions {
    title?: string;
    actions: BottomSheetActions[];
    cancellable?: boolean;
}

@Component({
    selector: 'app-bottom-sheet',
    templateUrl: './bottom-sheet.component.html',
    styleUrls: ['./bottom-sheet.component.scss'],
})
export class BottomSheetComponent {
    constructor(
        private _bottomSheetRef: MatBottomSheetRef<BottomSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public options: BottomSheetOptions,
    ) {}

    select(event: MouseEvent, selectedChoice: string): void {
        event.preventDefault();
        this._bottomSheetRef.dismiss(selectedChoice);
    }

    cancel(): void {
        this._bottomSheetRef.dismiss();
    }
}
